module.exports = __webpack_public_path__ + "c_static/img/1-4电脑淘宝购物车.0713085.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/收藏购物车/1-4电脑淘宝购物车.jpg
// module id = x4We
// module chunks = 33